import { z } from 'zod';

export const minLengthObservations = 5;

const reasonSchema = z.enum(
  [
    'there_was_problem_collecting',
    'trucker_could_not_collect',
    'gave_up_load_with_this_trucker',
    'documentation_problem',
    'client_canceled_the_collect',
    'other',
  ],
  {
    required_error: 'Selecione o motivo para cancelar a viagem',
  },
);

const cancelSchema = z
  .object({
    reason: reasonSchema,
    observations: z.string().optional().default(''),
  })
  .refine(
    (fields) => {
      if (fields.reason !== 'other') {
        return true;
      }

      if (fields.observations.length >= minLengthObservations) {
        return true;
      }

      return false;
    },
    {
      message: `Digite ao menos ${minLengthObservations} caracteres para continuar`,
      path: ['observations'],
    },
  );

export default cancelSchema;
